/**
 * Created by Ning Jiang on 4/10/2019.
 */

export class PPReelSymbolName {
    public static readonly X:string = "X"; // X is a local only special symbol will be replaced with X number of stacked W in run time.
}